import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { signOut } from '../lib/api'

export default function Logout() {
  const navigate = useNavigate()

  useEffect(() => {
    signOut().finally(() => navigate('/login', { replace: true }))
  }, [navigate])

  return (
    <div className="min-h-screen bg-gray-950" />
  )
}
